import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { PublicOnboardingService } from "../../../services/api/public-onboarding.service";
import { VendorActions } from "../../actions/vendor.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class VendorOnboardingEffects {
	activate = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.account.create),
			switchMap((action) =>
				this.publicOnboardingService.createNewVendor(action).pipe(
					map(() => VendorActions.account.createSuccess()),
					catchError((error) =>
						of(VendorActions.account.createFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private publicOnboardingService: PublicOnboardingService
	) {}
}
